export default "__VITE_ASSET__CLkF96V4__"